<div class="search-empty">
  <app-state-notice
    iconPath="/assets/illustrations/no_projects.svg"
    [title]="'search.map.empty.header' | translate"
    [desc]="getDescription()"
    [dense]="dense()"
  ></app-state-notice>

  @if (isMainApp) {
  <button class="button button--primary button--large" (click)="sendMail()">
    {{ 'search.map.empty.submit' | translate }}
  </button>
  } @if (showText) {
  <p
    [innerHTML]="
      'search.map.empty.alternative' | translate : { recipient: emailRecipient }
    "
  ></p>
  }
</div>
